//这里面是所有的方法名称
export const SET_NAV_INDEX = 'SET_NAV_INDEX';

export const PROJECT_CONFIG = 'PROJECT_CONFIG';
export const HASH_MENUS = 'HASH_MENUS';
